// Generated by CoffeeScript 1.12.7
(function () {
  Viewthespace.ShadowboxRemoteLink = (function () {
    var shadowBoxOnClose;

    shadowBoxOnClose = function () {
      var $flash;
      $flash = $("#flash");
      new Viewthespace.Flash($flash.attr("data-notice")).show();
      return $flash.removeAttr("data-notice");
    };

    function ShadowboxRemoteLink(link, height, width) {
      if (link.length > 0) {
        Shadowbox.setup(link, {
          player: "iframe",
          height: height,
          width: width,
          onClose: shadowBoxOnClose,
        });
      }
    }

    return ShadowboxRemoteLink;
  })();
}.call(this));
